import { render } from "./authenticate.vue?vue&type=template&id=bc225e2e"
import script from "./authenticate.vue?vue&type=script&lang=js"
export * from "./authenticate.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__